import axiosInstance from '../axios/axiosInstance';

export async function createMediaRoomAPI (data) {
  const { name, heading, subheading, templateId, collections, backgroundImage, collectionsperRow } = data;

  const response = await axiosInstance.post(
    '/media-rooms',
    { name, heading, subheading, templateId, collections, backgroundImage, collectionsperRow },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
  return response;
}

export async function getMediaRoomsAPI () {
  try {
    const response = await axiosInstance.get('/media-rooms');
    return response.data;
  } catch (error) {
    console.error('Error fetching Media Rooms:', error);
    throw error;
  }
}

export async function getMediaRoomByIdAPI (mediaRoomId) {
  try {
    const response = await axiosInstance.get(`/media-rooms/${mediaRoomId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Media Room:', error);
    throw error;
  }
}

export async function updateMediaRoomAPI (mediaRoomId, data) {
  try {
    const response = await axiosInstance.patch(`/media-rooms/${mediaRoomId}`, {
      ...data, id: mediaRoomId
    });
    return response.data;
  } catch (error) {
    console.error('Error updating Media Room:', error);
    throw error;
  }
}

export async function deleteMediaRoomAPI (mediaRoomId) {
  try {
    const response = await axiosInstance.delete(`/media-rooms/${mediaRoomId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting Media Room:', error);
    throw error;
  }
}

export async function renameMediaRoomAPI (id, newName) {
  try {
    const response = await axiosInstance.patch(`/media-rooms/${id}`, {
      name: newName
    });
    return response.data;
  } catch (error) {
    console.error('Rename API Error:', error.response?.data || error.message);
    throw error;
  }
}

export async function generateShareableLinkAPI (mediaRoomId) {
  try {
    const response = await axiosInstance.post(`/media-rooms/${mediaRoomId}/share`);
    return response.data?.result?.shareableLink || null;
  } catch (error) {
    console.error('Error generating shareable link:', error);
    throw error;
  }
}
